module.exports = __webpack_public_path__ + "static/media/joffre-9.29489b7c.jpg";